import styled from 'styled-components'

import { theme } from '../../constants/theme'

import { Link } from './Link'

export const HoverLink = styled(Link)`
  &&&&&:hover{
    color: ${theme.colors.blueFacm};
  }
`
